export const isTransparentBackground = (backgroundColor: string) =>
  backgroundColor === 'transparent' || backgroundColor === 'rgba(0, 0, 0, 0)';
